import React from 'react';

const IconLogo = () => (
<svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
  <title>Logo</title>
  <g transform="translate(-8, -2)">
    <g transform="translate(11, 5)">
      <polygon
        id="Shape"
        stroke="currentColor"
        stroke-width="5"
        stroke-linecap="round"
        stroke-linejoin="round"
        points="39 0 0 22 0 67 39 90 78 68 78 23"
      />
     <path
  d="M45 41 C40 39, 35 39, 30 41 C25 44, 25 49, 30 51 L40 56 C45 59, 45 64, 40 66 C35 68, 30 66, 27 64"
  stroke="currentColor"
  stroke-width="5"
  fill="none"
  stroke-linecap="round"
/>
    </g>
  </g>
</svg>
);

export default IconLogo;
